import { AbstractLocalDataAccessLayer } from "@/lib/utility/data/local-data-access-layer.abstract";
import { IDocumentRequest, DocumentRequest } from "@/models/document-request.entity";

export const DocumentRequestDataAccessLayer = new (class extends AbstractLocalDataAccessLayer<IDocumentRequest, ""> {
  getIdentifier(entity: IDocumentRequest): string {
    return entity.id;
  }

  mapEntity(entity: IDocumentRequest): IDocumentRequest {
    return new DocumentRequest(entity);
  }
})();
